import React from 'react'

import styled from 'styled-components'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const FullImageRecipeCardComponent = ({ hit, className, localFiles }) => {
  const images = localFiles
    .filter((localFile) => localFile.name && localFile.childImageSharp)
    .filter((localfile) => localfile.name.includes(hit.id))

  return (
    <a
      target="_blank"
      rel="noreferrer"
      href={`https://www.chefclub.tv${hit.absolute_url}`}
      className={className}
    >
      {images.length > 0 ? (
        <GatsbyImage
          style={{ width: '100%' }}
          image={getImage(images[0].childImageSharp)}
          alt=""
        />
      ) : (
        <div
          className="image"
          style={{ backgroundImage: `url(${hit.web_cover_thumbnail})` }}
        />
      )}
      <div className="infos">
        <h4>{hit.title}</h4>
        <p>{hit.subtitle}</p>
      </div>
    </a>
  )
}

const FullImageRecipeCard = styled(FullImageRecipeCardComponent)`
  width: 100%;
  height: 100%;

  color: black;
  text-decoration: none;

  position: relative;
  display: flex;
  flex-direction: column;
  column-gap: 10px;
  align-items: center;

  .image {
    width: 100%;
    height: 100%;
    background-position: center;
    background-size: cover;
  }

  :hover {
    .infos {
      top: 60%;
      opacity: 1;
    }
  }

  .infos {
    background: rgba(255, 255, 255, 0.8);
    opacity: 0;
    position: absolute;
    top: 100%;
    bottom: 0;
    transition: ease-in-out 150ms;
    width: calc(100% - 20px);
    border-radius: 10px 10px 0 0;
    padding: 10px;

    h4 {
      margin: 0 0 5px 0;
      font-size: smaller;
    }

    p {
      font-size: 75%;
      margin: 0;
    }
  }
`

export default FullImageRecipeCard
